import ApiServiceV2 from '@/helpers/api.service.v2';

const APIV2 = new ApiServiceV2();

export const state = {
    loanKpi: {},
    loanRows: [],
    loanPageInfo: { total: 0 }
};

export const mutations = {
    SET_LOAN_KPI(state, message) {
        state.loanKpi = message || {};
    },
    SET_LOAN_LIST(state, message) {
        state.loanRows = message?.rows || [];
        state.loanPageInfo = message?.pageInfo || { total: 0 };
    }
};

export const actions = {
    // POST /puhunan/loans/kpi -> { totalDisbursedAmount, successfullyDisbursed, completedLoans, averageLoanAmount }
    getPuhunanLoansKPI(context, params) {
        return new Promise((resolve, reject) => {
            APIV2.post('/puhunan/loans/kpi', params)
                .then((response) => {
                    if (response.data.status === 'ok') {
                        context.commit('SET_LOAN_KPI', response.data.message);
                    }
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    // POST /puhunan/loans/list -> { rows, pageInfo }
    getPuhunanLoansList(context, params) {
        return new Promise((resolve, reject) => {
            APIV2.post('/puhunan/loans/list', params)
                .then((response) => {
                    if (response.data.status === 'ok') {
                        context.commit('SET_LOAN_LIST', response.data.message);
                    }
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    // POST /puhunan/loans/export -> emails the full filtered set as xlsx
    exportPuhunanLoans(_, params) {
        return new Promise((resolve, reject) => {
            APIV2.post('/puhunan/loans/export', params)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

export const getters = {
    loanKpi: (state) => state.loanKpi,
    loanRows: (state) => state.loanRows,
    loanPageInfo: (state) => state.loanPageInfo
};
